// @flow

import React, { Fragment } from "react";
import className from "classnames";
import { Button, Row, Col } from "../../..";
import type { ColumnType } from "../../types";

type Props = {|
  column: ColumnType,
  className?: string,
|};

export const Column = (props: Props) => (
  <Fragment>
    {(props.column.columnTitle || props.column.columnButtons) && (
      <Row noGutters={true}>
        <Col
          className={className(
            "d-flex justify-content-between align-items-baseline column-title-container",
            props.className,
          )}
        >
          {props.column.columnTitle && (
            <h6 className="font-weight-bold">{props.column.columnTitle}</h6>
          )}
          {props.column.columnButtons && (
            <div
              className={className("d-flex", {
                "flex-column": props.column.verticalColumnButtons,
              })}
            >
              {props.column.columnButtons
                .filter(button => !button.hidden)
                .map(button => (
                  <Button
                    size="small"
                    key={button.text}
                    className={className("ml-2", button.className, {
                      "mb-4": props.column.verticalColumnButtons,
                    })}
                    color={button.color}
                    onClick={button.onClick}
                  >
                    {button.text}
                  </Button>
                ))}
            </div>
          )}
        </Col>
      </Row>
    )}
    {!props.column.subColumns && (
      <Row noGutters={true}>
        <Col>
          {props.column.data &&
            props.column.data.map((keyValue, index) => (
              <Fragment key={`data-${index}`}>
                <hr className="my-2" />
                <div className="pb-1 row-label">{keyValue[0]}</div>
                <div className="row-value">{keyValue[1]}</div>
              </Fragment>
            ))}
        </Col>
      </Row>
    )}
  </Fragment>
);

export default Column;
